/** Packages **/
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './styles.scss';

const LogoHome = () => {
  const { labels } = useLanguage();
  const commonLabels = labels.commonLabels || {};
  return (
    <div className="LogoHome">
      <h5>{commonLabels.ALTITUDE}</h5>
      <h6>{commonLabels.CREW_INTERFACE}</h6>
    </div>
  );
};

export default LogoHome;
